<template>
  <div id="modal" :class="[openSidenav ? isSidenavOpen: isSidenavClose]" v-if="isVisible">
    <div class="div-body">
      <div class="div-img">
        <img class="img-doodle" :src="image" @error="imageError">
      </div>

      <div class="div-close">
        <button type="button" class="close" @click="close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </div>  
</template>

<script>
export default {
    data(){
        return {
            isSidenavOpen: 'modalOpenSideNav',
            isSidenavClose: 'modalCloseSideNav',
            openSidenav: false,
            isVisible : true,
            image: ''
        }
    },
    created(){
         const year = new Date().getFullYear();
         const month = ('' + (new Date().getMonth() + 1)).length == 1 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
         const day = ('' + new Date().getDate()).length == 1 ? '0' + new Date().getDate() : new Date().getDate();
         this.image = 'http://www.geodir.co/resources/images/doodles/geodir-doodle-' + year + month + day + '.png';
    },
    mounted(){
        let app = this;
        this.$store.watch(this.$store.getters.isOpenSidenav, openSidenav => {
        		app.openSidenav=openSidenav;
        });
    },
    methods:{
        close(){
            this.isVisible = false;
        },
        imageError() {
            this.image = 'http://www.geodir.co/resources/images/doodles/geodir-doodle-default.png';
        }
    }
};
</script>

<style scoped>
.modalOpenSideNav {
  left: 330px;
  top: 65px;
  position: fixed;
  box-sizing: border-box;
  padding: 0px;
  transition: 0.22s;
  background-color: transparent;
  z-index: 999;
  border-radius: 2px;
}

.modalCloseSideNav {
  left: 10px;
  top: 65px;
  position: fixed;
  box-sizing: border-box;
  padding: 0px;
  transition: 0.2s;
  background-color: transparent;
  z-index: 999;
  border-radius: 2px;
}

.div-img {
  display: inline-block;
}

.div-close {
  width: 20px;
  height: 45px;
  margin: 0 0 63px 0;
  background-color: #ffffff;
  display: inline-block;
}

.close {
  width: 20px;
  height: 45px;
  border-color: transparent transparent transparent #6c757d;
}

.img-doodle {
  width: 390px;
}

@media (max-width: 360px) {
  #modal {
    width: 320px;
  }

  .img-doodle {
    width: 300px;
  }

  .div-close {
    margin: 0 0 39px 0;
  }
}
</style>

